// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3226":"bb03aeeb","7291":"bb03aeeb"}[chunkId] + ".chunk.css";
};